import React, { useEffect, useState } from "react";
import { Modal, ProgressBar } from "react-bootstrap";
import { toast } from "react-toastify";
import FormGenerator from "../../form-generator/FormGenerator";
import { makeRESTApiRequests } from "../../helpers/api";
import { ENDPOINTS } from "../../helpers/constants";
import { formJson } from "./form";

const TaskAddEdit = ({
  onTaskAddEdit,
  show,
  onHide,
  editingTask,
  editingTaskIndex,
  jobId,
  tasks = [],
}) => {
  const [submittingTask, setSubmittingTask] = useState(false);
  const [preFill, setPreFill] = useState();

  const [hide, setHide] = useState(false);

  useEffect(() => {
    setHide(true);
    setTimeout(() => {
      if (!editingTask) {
        setPreFill(undefined);
      } else {
        setPreFill(editingTask);
      }
      setHide(false);
    }, 50);
  }, [editingTask]);

  const onTaskAddSubmit = async (form) => {
    setSubmittingTask(true);
    let task = preFill
      ? {
          ...preFill,
          ...form,
        }
      : {
          ...form,
          Status: "Incomplete",
        };

    let requestTasks = tasks ? [...tasks] : [];
    if (editingTaskIndex !== -1) {
      requestTasks[editingTaskIndex] = task;
    } else {
      requestTasks = [task, ...requestTasks];
    }

    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.UPDATE_INDIVIDUAL_JOB(jobId),
      method: "PUT",
      requestBody: {
        tasks: requestTasks,
      },
    });

    setSubmittingTask(false);

    if (error) {
      toast(error, {
        type: "error",
      });
      return;
    }

    onTaskAddEdit(
      {
        ...task,
      },
      editingTaskIndex
    );
  };

  window["onTaskAddSubmit"] = onTaskAddSubmit;

  return (
    <>
      <Modal show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton={!submittingTask}>
          <Modal.Title>{editingTask ? "Update" : "New"} task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!hide && (
            <FormGenerator
              formJson={formJson}
              formValues={preFill ? { "New Task": preFill } : {}}
              prefix="task"
            />
          )}
          {submittingTask && (
            <ProgressBar
              variant="dark"
              animated
              now={100}
              label="Adding task..."
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TaskAddEdit;
